<template>
    <div class="badge">
        <div class="label">{{span}}</div>
        <div class="price">{{label}}</div>
    </div>
</template>

<script>
export default {
    props: {
        label: String,
        span: String
    }
}
</script>